import { memo } from 'react';

import { Flex } from '@/components/core';
import { ActionRunTest, HttpHeaders, HttpMethod, HttpUrl } from '@/components/flow';

export type ExportWebhookConfigurationProps = object;

// eslint-disable-next-line no-empty-pattern
const IExportWebhookConfiguration = ({}: ExportWebhookConfigurationProps = {}) => {
  return (
    <Flex col className="gap-md p-md">
      <HttpUrl placeholder="https://webhook.site/path" />
      <HttpMethod />
      <HttpHeaders />
      <ActionRunTest />
    </Flex>
  );
};

export const ExportWebhookConfiguration = memo(IExportWebhookConfiguration) as typeof IExportWebhookConfiguration;
